// Package users.v3 defines the protocol buffer messages and services for user management
// within the platform. This includes user profiles, authentication states, and user-related
// metadata.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file users/v3/user.proto (package users.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { AuditMetadata } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { LanguageRegion } from "../../i18n/v3/language_regions_pb";
import { file_i18n_v3_language_regions } from "../../i18n/v3/language_regions_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file users/v3/user.proto.
 */
export const file_users_v3_user: GenFile = /*@__PURE__*/
  fileDesc("ChN1c2Vycy92My91c2VyLnByb3RvEgh1c2Vycy52MyKLBAoEVXNlchIZCgJpZBgBIAEoCUINmrUYCXN0aWQuVXNlchIPCgd2ZXJzaW9uGAIgASgDEhgKEGV4dGVybmFsX2F1dGhfaWQYAyABKAkSDAoEZXRhZxgEIAEoCRIVCg1wcmltYXJ5X2VtYWlsGAUgASgJEhQKDGRpc3BsYXlfbmFtZRgGIAEoCRIXCgpnaXZlbl9uYW1lGAcgASgJSACIAQESGAoLZmFtaWx5X25hbWUYCCABKAlIAYgBARIuChBsaWZlY3ljbGVfc3RhdHVzGAkgASgOMhQudXNlcnMudjMuVXNlclN0YXR1cxIhCgVmbGFncxgKIAMoDjISLnVzZXJzLnYzLlVzZXJGbGFnEjAKD2xhbmd1YWdlX3JlZ2lvbhgLIAEoDjIXLmkxOG4udjMuTGFuZ3VhZ2VSZWdpb24SKgoKZW1haWxfbGlzdBgMIAMoCzIWLnVzZXJzLnYzLkVtYWlsQWRkcmVzcxIsCgphYnVzZV9tYXJrGA0gASgLMhMudXNlcnMudjMuQWJ1c2VNYXJrSAKIAQESDQoFc2NvcmUYDiABKAUSFwoKYXZhdGFyX3VybBhlIAEoCUgDiAEBQg0KC19naXZlbl9uYW1lQg4KDF9mYW1pbHlfbmFtZUINCgtfYWJ1c2VfbWFya0INCgtfYXZhdGFyX3VybEoECA8QZUoFCGYQyQEicQoMRW1haWxBZGRyZXNzEg0KBWVtYWlsGAEgASgJEgwKBHR5cGUYAiABKAkSNAoLdmVyaWZpZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQFCDgoMX3ZlcmlmaWVkX2F0Ij0KCUFidXNlTWFyaxIwCg5hdWRpdF9tZXRhZGF0YRgDIAEoCzIYLmNvbW1vbi52My5BdWRpdE1ldGFkYXRhIm4KDFVzZXJJbnRlcm5hbBIcCgR1c2VyGAEgASgLMg4udXNlcnMudjMuVXNlchJAChltYWludGVuYW5jZV9hY3Rpdml0eV9saXN0GAMgAygOMh0udXNlcnMudjMuTWFpbnRlbmFuY2VBY3Rpdml0eSr5AQoKVXNlclN0YXR1cxIbChdVU0VSX1NUQVRVU19VTlNQRUNJRklFRBAAEhUKEVVTRVJfU1RBVFVTX0dVRVNUEAESJAogVVNFUl9TVEFUVVNfUEVORElOR19WRVJJRklDQVRJT04QAhIaChZVU0VSX1NUQVRVU19SRUdJU1RFUkVEEAMSGAoUVVNFUl9TVEFUVVNfSU5BQ1RJVkUQBBIgChxVU0VSX1NUQVRVU19NQVJLRURfRk9SX0FCVVNFEAUSIAocVVNFUl9TVEFUVVNfREVMRVRFX1JFUVVFU1RFRBAGEhcKE1VTRVJfU1RBVFVTX0RFTEVURUQQBypACghVc2VyRmxhZxIZChVVU0VSX0ZMQUdfVU5TUEVDSUZJRUQQABIZChVVU0VSX0ZMQUdfV0hJVEVfR0xPVkUQASpBChNNYWludGVuYW5jZUFjdGl2aXR5EiQKIE1BSU5URU5BTkNFX0FDVElWSVRZX1VOU1BFQ0lGSUVEEAAiBAgBEGRCWVpXZ2l0aHViLmNvbS9TdG9yeXRlbGwtYWkvc3Rvcnl0ZWxsLWFpLXBsYXRmb3JtL3BrZy9nby9kb21haW5zL2NwL2dlbi9wYi91c2Vycy92Mzt1c2Vyc1YzYgZwcm90bzM", [file_common_v3_common, file_i18n_v3_language_regions, file_google_protobuf_timestamp]);

/**
 * User represents a user profile within the platform.
 * This is the primary message for user-related operations and queries.
 *
 * @generated from message users.v3.User
 */
export type User = Message<"users.v3.User"> & {
  /**
   * Unique identifier for the user.
   * Format: ^user_[a-z0-9]{20}$
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Version number for optimistic concurrency control
   *
   * @generated from field: int64 version = 2;
   */
  version: bigint;

  /**
   * External authentication ID for the user as provided by the authentication
   * provider (e.g., Google Firebase).
   *
   * @generated from field: string external_auth_id = 3;
   */
  externalAuthId: string;

  /**
   * ETag for optimistic concurrency control
   *
   * @generated from field: string etag = 4;
   */
  etag: string;

  /**
   * Primary email address for the user
   *
   * @generated from field: string primary_email = 5;
   */
  primaryEmail: string;

  /**
   * User's display name (e.g., "John Smith")
   *
   * @generated from field: string display_name = 6;
   */
  displayName: string;

  /**
   * User's given/first name, if available.
   *
   * @generated from field: optional string given_name = 7;
   */
  givenName?: string;

  /**
   * User's family/last name, if available
   *
   * @generated from field: optional string family_name = 8;
   */
  familyName?: string;

  /**
   * Current lifecycle status of the user
   *
   * @generated from field: users.v3.UserStatus lifecycle_status = 9;
   */
  lifecycleStatus: UserStatus;

  /**
   * Special flags or privileges assigned to the user
   *
   * @generated from field: repeated users.v3.UserFlag flags = 10;
   */
  flags: UserFlag[];

  /**
   * The language region of the user, which drives localization for this user.
   * Example: en-US
   *
   * @generated from field: i18n.v3.LanguageRegion language_region = 11;
   */
  languageRegion: LanguageRegion;

  /**
   * A list of other email addresses associated with the user.
   * The primary email address should always be included in this list.
   *
   * @generated from field: repeated users.v3.EmailAddress email_list = 12;
   */
  emailList: EmailAddress[];

  /**
   * Optional abuse marking information if the user has been flagged
   *
   * @generated from field: optional users.v3.AbuseMark abuse_mark = 13;
   */
  abuseMark?: AbuseMark;

  /**
   * A score assigned to a user based on various signals such as their email address
   * or a deeper understanding of the user. This score is considered when gating
   * access to free-plan users.
   *
   * @generated from field: int32 score = 14;
   */
  score: number;

  /**
   * URL to the user's avatar/profile picture, if available
   *
   * @generated from field: optional string avatar_url = 101;
   */
  avatarUrl?: string;
};

/**
 * Describes the message users.v3.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_users_v3_user, 0);

/**
 * EmailAddress represents an email address associated with a user.
 *
 * @generated from message users.v3.EmailAddress
 */
export type EmailAddress = Message<"users.v3.EmailAddress"> & {
  /**
   * The email address
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * The type of email address (e.g., "work", "personal")
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * Timestamp when the email was verified, if applicable
   *
   * @generated from field: optional google.protobuf.Timestamp verified_at = 5;
   */
  verifiedAt: Timestamp;
};

/**
 * Describes the message users.v3.EmailAddress.
 * Use `create(EmailAddressSchema)` to create a new message.
 */
export const EmailAddressSchema: GenMessage<EmailAddress> = /*@__PURE__*/
  messageDesc(file_users_v3_user, 1);

/**
 * AbuseMark represents information about abuse-related actions taken against a user.
 *
 * @generated from message users.v3.AbuseMark
 */
export type AbuseMark = Message<"users.v3.AbuseMark"> & {
  /**
   * Audit metadata for tracking when and why the abuse mark was applied
   *
   * @generated from field: common.v3.AuditMetadata audit_metadata = 3;
   */
  auditMetadata: AuditMetadata;
};

/**
 * Describes the message users.v3.AbuseMark.
 * Use `create(AbuseMarkSchema)` to create a new message.
 */
export const AbuseMarkSchema: GenMessage<AbuseMark> = /*@__PURE__*/
  messageDesc(file_users_v3_user, 2);

/**
 * UserInternal represents a user within the boundaries of the system and includes
 * information that may not be useful to external clients. This information may drive
 * entitlements and other internal decisions.
 *
 * @generated from message users.v3.UserInternal
 */
export type UserInternal = Message<"users.v3.UserInternal"> & {
  /**
   * The base user information
   *
   * @generated from field: users.v3.User user = 1;
   */
  user: User;

  /**
   * A list of maintenance activities performed for this user. This allows us
   * to recall any maintenance activities performed for this user when deciding
   * if work needs to be done on-demand when a user returns or as part of
   * bulk maintenance jobs.
   *
   * @generated from field: repeated users.v3.MaintenanceActivity maintenance_activity_list = 3;
   */
  maintenanceActivityList: MaintenanceActivity[];
};

/**
 * Describes the message users.v3.UserInternal.
 * Use `create(UserInternalSchema)` to create a new message.
 */
export const UserInternalSchema: GenMessage<UserInternal> = /*@__PURE__*/
  messageDesc(file_users_v3_user, 3);

/**
 * UserStatus represents the current state of a user within the platform.
 * These states drive access control and system behavior.
 *
 * @generated from enum users.v3.UserStatus
 */
export enum UserStatus {
  /**
   * @generated from enum value: USER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Temporary user with limited access
   *
   * @generated from enum value: USER_STATUS_GUEST = 1;
   */
  GUEST = 1,

  /**
   * User is pending verification and cannot access the system
   *
   * @generated from enum value: USER_STATUS_PENDING_VERIFICATION = 2;
   */
  PENDING_VERIFICATION = 2,

  /**
   * Fully registered and verified user
   *
   * @generated from enum value: USER_STATUS_REGISTERED = 3;
   */
  REGISTERED = 3,

  /**
   * User is inactive and cannot access the system
   *
   * @generated from enum value: USER_STATUS_INACTIVE = 4;
   */
  INACTIVE = 4,

  /**
   * User is marked for abuse and cannot access the system
   *
   * @generated from enum value: USER_STATUS_MARKED_FOR_ABUSE = 5;
   */
  MARKED_FOR_ABUSE = 5,

  /**
   * User has requested deletion and cannot access the system
   *
   * @generated from enum value: USER_STATUS_DELETE_REQUESTED = 6;
   */
  DELETE_REQUESTED = 6,

  /**
   * User is deleted and cannot access the system
   *
   * @generated from enum value: USER_STATUS_DELETED = 7;
   */
  DELETED = 7,
}

/**
 * Describes the enum users.v3.UserStatus.
 */
export const UserStatusSchema: GenEnum<UserStatus> = /*@__PURE__*/
  enumDesc(file_users_v3_user, 0);

/**
 * UserFlag represents special attributes or privileges assigned to users.
 * These flags can modify system behavior or entitlements for specific users.
 *
 * @generated from enum users.v3.UserFlag
 */
export enum UserFlag {
  /**
   * @generated from enum value: USER_FLAG_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * User has been flagged for white glove service allowing for human
   * intervention should they face challenges
   *
   * @generated from enum value: USER_FLAG_WHITE_GLOVE = 1;
   */
  WHITE_GLOVE = 1,
}

/**
 * Describes the enum users.v3.UserFlag.
 */
export const UserFlagSchema: GenEnum<UserFlag> = /*@__PURE__*/
  enumDesc(file_users_v3_user, 1);

/**
 * MaintenanceActivity represents different types of maintenance operations
 * that can be performed on a user account.
 *
 * @generated from enum users.v3.MaintenanceActivity
 */
export enum MaintenanceActivity {
  /**
   * @generated from enum value: MAINTENANCE_ACTIVITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,
}

/**
 * Describes the enum users.v3.MaintenanceActivity.
 */
export const MaintenanceActivitySchema: GenEnum<MaintenanceActivity> = /*@__PURE__*/
  enumDesc(file_users_v3_user, 2);

